'use client'

import MainSearch from "../component/Responsive/searchfilter/SearchGetData"



const SearchPage = ({ search, tag }) => {

    return (
        <MainSearch search={search} tag={tag} />
    )
}

export default SearchPage  